import { Text } from '@shared/components/Text';
import { grid } from '@shared/styles';
import { MBBaseSystemMessage } from './base';
import { toString } from './toString';
import { MBSystemMessageProps } from './index';

export function ChannelCreated({ message, ...otherProps }: MBSystemMessageProps) {
  return (
    <MBBaseSystemMessage
      {...otherProps}
      image={<Text size="body2">👋</Text>}
      text={toString(message)}
      date={message.createdAt}
    />
  );
}

export function MessageRemoved({ message, ...otherProps }: MBSystemMessageProps) {
  return (
    <MBBaseSystemMessage
      {...otherProps}
      text={toString(message)}
      date={message.createdAt}
      style={{ marginTop: grid(2) }}
    />
  );
}
